export default __webpack_public_path__ + "static/1-setting-e8e19fccb0c58d0de8deb1a30633f3c9.png";